import axios from 'axios'

export default {
    getAllApprovalRequests (searchText, page, rows, sortColumn, order) {
        return axios.get(`/api/approval-requests?search=${searchText}&page=${page}&rows=${rows}&column=${sortColumn}&order=${order}`)
    },
    getApprovalRequest(id) {
        return axios.get(`/api/approval-requests/${id}`)
    },
    updateApprovalStatus({ requests, status }) {
        return axios.patch(`/api/approval-requests/status`, {
            requests,
            status
        });
    },
    deleteApprovalRequests({requests}) {
        return axios.delete(`/api/approval-requests/delete`, {
            data: {
                requests: requests
            }
        });
    },
    processApprovalRequest(payload) {
        const url = `/api/approval-requests/${payload.request_id}/${payload.action}`;
        const data = {
          ...payload
        };
        return axios.post(url, data)
    },
    getApprovalsCount () {
        return axios.get('/api/approvals/count')
    }
}